import { Contract, Seat, SEATS } from "@ravalmatic/bridge-engine/core";
import { DevelopmentPreferences } from "../../../Types";

export type DevelopmentSeats = DevelopmentPreferences;

export function createDevelopmentContract(declarer?: Seat): Contract {

    const doubling = Phaser.Math.Between(0, 2);
    return {
        level: Phaser.Math.Between(1, 7),
        strain: ([0, 1, 2, 3, 4] as const)[Phaser.Math.Between(0, 4)],
        declarer: declarer ?? SEATS[Phaser.Math.Between(0, SEATS.length - 1)],
        doubled: doubling !== 0,
        redoubled: doubling === 2
    };
}
